import React from 'react';
import "./Header.css"
// import PropTypes from 'prop-types';

// Header.propTypes = {
    
// };

function Header(props) {
    return (
        <div className="row title_div">
            <div className="col-sm-1 title_img_div d-flex justify-content-center">
                <img src={require('./../assets/images/logo-3cx.PNG')} className="header-logo" alt="logo" />
            </div>
            <div className="col-sm title_text_div d-flex justify-content-center">Outbound Dashboard</div>
            <div className="col-sm-1 title_text_div"></div>
        </div>
    );
}

export default Header;